module.exports = __webpack_public_path__ + "static/img/zs-nv@2x.6a66e526.png";